import { Container, makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import {
  CircularProggressIndicator,
  ShopRegionHeadline,
} from "../components-atoms";
import { InfoCard } from "../components-molecules/InfoCard";
import { ITheme } from "../constants/theme";
import { IShopByMerchant, IShopByMerchantResponse } from "../redux/reducers/getShopNames";
import { getOrderDate } from "../utils/dateTimeFormatting";

interface INotification {
  Id: string;
  Title: string;
  Body: string;
  Created: Date;
  Shops?: string[]
  Customers?: string[];
}
type SortedList = {
  GroupName: string;
  Notifications: INotification[];
}[];
interface IProps {
  list: IShopByMerchantResponse[];
  query: string;
}
export const PushNotificationList = ({ list, query }: IProps) => {
  const classes = useStyles();
  const [notifications, loading]: [SortedList, boolean] = useSelector(
    (state: any) => [
      state.PushNotificationReducer.data as SortedList,
      state.PushNotificationReducer.loading,
    ]
  );

  const getShopList = (item: INotification): string => {
    const flatShops: IShopByMerchant[] = list.flatMap((m) => m.Shops);
    return item?.Shops && item?.Shops.length > 0 ? item.Shops.map(
      (shop) => flatShops.find((f) => f.ShopId === shop)?.ShopName || ""
    ).reduce((prev, next) => `${prev}, ${next}`) : "";
  }

  const getCustomerList = (item: INotification): string =>
    item.Customers && item.Customers.length > 0 ? "Customers: " + item?.Customers.join(", ") : "";

  const bottomText = (item: INotification): string => {
    return `${getOrderDate(item.Created)} · ${item.Shops && getShopList(item)} ${item.Customers && getCustomerList(item)}`;
  };

  return (
    <Container className={classes.component}>
      {loading ? (
        <CircularProggressIndicator />
      ) : !notifications || notifications.length === 0 ? (
        !query ? (
          <Container className={classes.noRecordsFound}>
            <Typography variant="body1" component="span">
              No records found
            </Typography>
          </Container>
        ) : (
          <Container className={classes.noRecordsFound}>
            <Typography variant="h6" component="span" color="textPrimary">
              0 search results found
            </Typography>
            <Typography variant="body2" component="span" color="textSecondary">
              Adjust your search term and try again
            </Typography>
          </Container>
        )
      ) : (
        <>
          {notifications.map((sortedItem, index) => (
            <div key={sortedItem.GroupName}>
              {sortedItem.Notifications.length > 0 && (
                <ShopRegionHeadline
                  data-automation="number-of-codes"
                  headlineTypeSingular="Notification"
                  headLineTypePlural="Notifications"
                  data={{
                    header: sortedItem.GroupName,
                    count: sortedItem.Notifications.length,
                  }}
                />
              )}
              {sortedItem.Notifications.map((item: INotification) => (
                <InfoCard
                  key={item.Id}
                  data={{
                    ...item,
                    bottomText: bottomText(item),
                    topText: item.Title,
                    body: item.Body,
                  }}
                  secondGrid={8}
                  thirdGrid={4}
                  disabled={true}
                  showMoreEnabled={true}
                ></InfoCard>
              ))}
            </div>
          ))}
        </>
      )}
    </Container>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  component: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 0,
    paddingRight: 0,
    marginTop: 24,
  },
  noRecordsFound: {
    display: "flex",
    paddingLeft: "24px",
    flexDirection: "column",
  },
  active: {
    color: theme.palette.success.main,
    fontWeight: 700,
    paddingRight: 12,
  },
  archived: {
    color: theme.palette.error.main,
    fontWeight: 700,
    paddingRight: 12,
  },
}));
